import { apiRequest } from '../client';
import type { PageResponse } from '../types';

export type PackIdentityStatus = 'DRAFT' | 'READY' | 'PUBLISHED' | 'WITHDRAWN';

export interface PublishabilityIssue {
  field: string;
  message: string;
}

export interface PublishabilityResult {
  issues: PublishabilityIssue[];
}

export interface PackPassportPayload {
  qrToken: string;
  packSerialNumber: string;
  manufacturer: { code: string; legalName: string; jurisdiction: string };
  descriptor: {
    chemistry: string;
    nominalVoltage: number;
    capacityAh: number;
    energyWh: number;
    weightKg: number;
  };
  materials: Array<{
    materialCode: string;
    materialName: string;
    percentage: number;
    recyclable: boolean;
  }>;
  carbonFootprint: { totalCo2eKg: number; methodology: string };
  lifecycle: Array<{ type: string; occurredAt: string }>;
  generatedAt: string;
}

export interface RegistryAccessLogEntry {
  id: string;
  actor: string;
  action: 'VIEW_PUBLISHABILITY' | 'VIEW_EXPORT' | 'VIEW_PASSPORT';
  resourceType: string;
  resourceId: string | null;
  qrToken: string | null;
  requestPath: string;
  occurredAt: string;
}

export const registryApi = {
  publishability: (identityId: string) =>
    apiRequest<PublishabilityResult>(
      `/api/registry/identities/${identityId}/publishability`
    ),

  /** Public — no auth needed. Used by the QR-scan PassportPage. */
  passport: (qrToken: string) =>
    apiRequest<PackPassportPayload>(`/api/registry/passport/${encodeURIComponent(qrToken)}`),

  auditLog: (identityId: string, page = 0, size = 20) =>
    apiRequest<PageResponse<RegistryAccessLogEntry>>(
      `/api/registry/identities/${identityId}/audit-log?page=${page}&size=${size}`
    )
};
